/**
 * @hidden
 */
export class Configuration {
	protected data:{ [propety:string]:string } = {};

	constructor(data = null){
		if (data)
			this.data = data;
	}

	set(property:string, value:string):void{
		this.data[property] = value;
	}

	/**
	 * Tests rule againts configuration
	 * @param ruleString Rules
	 * @param failMissing Whether to fail, when configuration does not have property defined
	 * @return {boolean} whether rule matches
	 */
	test(ruleString:string, failMissing: boolean = true):boolean{
		for (let rule of ruleString.split(';')){
			let prop: string, val: string;
			[prop, val] = rule.split(':');
			if (this.data.hasOwnProperty(prop)){
				if (this.data[prop] != val)
					return false;
			}
			else if (failMissing)
				return false;
		}
		return true;	// all passed
	}

	serialize():string{
		let hashData:string[] = [];
		for (let p of Object.keys(this.data).sort())
			hashData.push(`${p}:${this.data[p]}`);
		return hashData.join(';');
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/Configuration.ts